import React from 'react';

export const CustomerCare = () => (
	<h1>Customer Care</h1>
);


// WEBPACK FOOTER //
// ./src/containers/CustomerCare/CustomerCare.js